// SEO Configuration for all pages
export const seoConfig = {
  home: {
    title: "Trademark Upgrades - Professional Trademark Registration Services USA",
    description: "Protect your brand with expert trademark registration services. Fast, affordable, and hassle-free trademark filing with 98% success rate. Starting at just $45 with 24-hour filing.",
    keywords: "trademark registration, trademark services, brand protection, USPTO filing, trademark attorney, intellectual property services"
  },
  
  about: {
    title: "About Us - Expert Trademark Registration Services",
    description: "Learn about Trademark Upgrades' mission to provide affordable, professional trademark registration services. 15+ years of experience with 98% success rate and 5000+ satisfied clients.",
    keywords: "about trademark services, trademark company, intellectual property firm, trademark experts"
  },
  
  services: {
    title: "Our Services - Trademark, Copyright & Company Formation",
    description: "Comprehensive intellectual property services including trademark registration, copyright filing, company formation, Amazon brand registry, and trademark search services.",
    keywords: "trademark services, copyright services, company formation, Amazon brand registry, trademark search, IP services"
  },
  
  trademarkRegistration: {
    title: "Trademark Registration Services - Fast & Affordable USPTO Filing",
    description: "Professional trademark registration services starting at $45. Expert attorneys, 24-hour filing, 98% success rate. Protect your brand nationwide with comprehensive trademark registration.",
    keywords: "trademark registration, USPTO filing, register trademark, trademark application, federal trademark, trademark protection"
  },
  
  copyrightRegistration: {
    title: "Copyright Registration Services - Protect Your Creative Works",
    description: "Expert copyright registration for literary works, music, art, software, photography, and audiovisual content. Fast filing with experienced attorneys.",
    keywords: "copyright registration, copyright protection, register copyright, copyright services, creative work protection"
  },
  
  companyFormation: {
    title: "Company Formation Services - LLC, Corporation & Business Setup",
    description: "Professional company formation services for startups and businesses. Expert guidance for LLC, corporation, and business entity setup.",
    keywords: "company formation, LLC formation, incorporate business, business setup, entity formation"
  },
  
  trademarkSearch: {
    title: "Free Trademark Search - Check Trademark Availability",
    description: "Comprehensive trademark search services to ensure your brand is available. Identify potential conflicts before filing with our expert trademark search.",
    keywords: "trademark search, trademark availability, trademark conflict search, USPTO search, brand availability"
  },
  
  amazonBrandRegistry: {
    title: "Amazon Brand Registry Services - Protect Your Amazon Brand",
    description: "Professional Amazon Brand Registry services to protect your products from counterfeiters and unauthorized sellers. Expert guidance for brand enrollment.",
    keywords: "Amazon Brand Registry, Amazon brand protection, Amazon trademark, brand enrollment, counterfeit protection"
  },
  
  contact: {
    title: "Contact Us - Get Expert Trademark Registration Help",
    description: "Contact Trademark Upgrades for professional trademark registration assistance. Chat with our expert attorneys or submit your inquiry for fast response.",
    keywords: "contact trademark services, trademark consultation, trademark help, IP attorney contact"
  },
  
  landingPage: {
    title: "Trademark Registration Made Easy - 98% Success Rate | Trademark Upgrades",
    description: "Register your trademark in 3 easy steps. Expert attorneys, 24-hour filing, affordable packages starting at $45. Trusted by 5,000+ businesses nationwide.",
    keywords: "easy trademark registration, fast trademark filing, affordable trademark services, trademark packages"
  },
  
  privacyPolicy: {
    title: "Privacy Policy - Trademark Upgrades",
    description: "Read our privacy policy to understand how we collect, use, and protect your personal information.",
    keywords: "privacy policy, data protection, personal information"
  },
  
  termsOfService: {
    title: "Terms of Service - Trademark Upgrades",
    description: "Terms and conditions for using Trademark Upgrades trademark registration services.",
    keywords: "terms of service, terms and conditions, service agreement"
  },
  
  thankYou: {
    title: "Thank You - Application Received | Trademark Upgrades",
    description: "Thank you for choosing Trademark Upgrades. Your trademark application has been received and our team will contact you shortly.",
    keywords: "trademark application submitted, thank you page"
  }
};
